import { Link } from '@tanstack/react-router';
import { CircleArrowLeft, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

import { useGetEmailToggles } from '~entities/settings/email-settings/api/get-email-toggles';
import { useUpdateAllEmailToggles } from '~entities/settings/email-settings/api/update-all-email-toggles';

import { EmailTogglesAllToggle } from './email-toggles-all-toggle';
import { EmailTogglesGrid } from './email-toggles-grid';

export const EmailSettings = () => {
  const { data: emailToggles, isFetching } = useGetEmailToggles();
  const { mutateAsync: updateAllToggles, isPending } =
    useUpdateAllEmailToggles();

  const handleToggleAll = async (checked: boolean) => {
    try {
      const { failed } = await updateAllToggles({
        toggles: emailToggles ?? [],
        disabled: !checked,
      });
      if (failed > 0) {
        toast.error(
          `Failed to update ${failed} email notification${failed === 1 ? '' : 's'}`,
        );
      } else {
        toast.success(
          `All email notifications ${checked ? 'enabled' : 'disabled'}`,
        );
      }
    } catch (error) {
      toast.error('Failed to update email notifications');
      console.error(error);
    }
  };

  return (
    <div className='min-w-0'>
      <Link to='/dashboard' className='flex min-w-0 items-center gap-2'>
        <CircleArrowLeft className='size-6 shrink-0' />
        <h2 className='min-w-0 text-xl font-semibold sm:text-2xl'>
          Email Settings
        </h2>
      </Link>
      <div className='mt-4 border-t pt-8'>
        {isFetching ? (
          <div className='flex justify-center py-8'>
            <Loader2 className='size-10 animate-spin' />
          </div>
        ) : (
          <div className='space-y-4'>
            <EmailTogglesAllToggle
              toggles={emailToggles ?? []}
              isPending={isPending}
              onToggle={handleToggleAll}
            />
            <EmailTogglesGrid
              toggles={emailToggles ?? []}
              disabled={isPending}
            />
          </div>
        )}
      </div>
    </div>
  );
};
